/**
 * capitalizeFirst: upper-cases the first letter of a label and leaves the
 * rest as written: a client's name on the maps, a first name in a confirm
 * button ("Add Ruth to contacts"), a SPICE fact. Typed record values read
 * through displayValue (@/lib/valueCase) instead.
 */

/** Capitalize the first non-whitespace character (locale-default upper). */
export function capitalizeFirst(s: string): string {
  const i = s.search(/\S/);
  if (i === -1) return s;
  const up = s[i]!.toUpperCase();
  return up === s[i] ? s : s.slice(0, i) + up + s.slice(i + 1);
}
